import * as React from "react"
import { Stack, Box, Typography } from "@mui/material"

export default function HelpAttributionModels() {
  return (
    <Stack spacing={0.5} sx={{ fontSize: "sm" }}>
      <Typography variant="h3">Attribution Models</Typography>
      <Box>
        There are 3 types of attribution models. Attribution refers to which ad
        source or social channel gets credit for an order.
      </Box>
      <Typography variant="h4" sx={{ fontWeight: 600, fontSize: "sm" }}>
        Last Touch
      </Typography>
      <Box>
        The last event in the customer journey gets attributed with the order.
      </Box>
      <Typography variant="h4" sx={{ fontWeight: 600, fontSize: "sm" }}>
        Multi Touch
      </Typography>
      <Box>
        An even spread across all events in the customer journey get attributed
        with a percentage of the order, except for the last event which gets 50%
        of the attribution.
      </Box>
      <Typography variant="h4" sx={{ fontWeight: 600, fontSize: "sm" }}>
        First Touch
      </Typography>
      <Box>
        Almost identical to last touch, The first event in the customer journey
        gets attributed with the order.
      </Box>
    </Stack>
  )
}
